"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlopeWalletAdapter = void 0;
const tslib_1 = require("tslib");
const web3_js_1 = require("@solana/web3.js");
const bs58 = (0, tslib_1.__importStar)(require("bs58"));
const eventemitter3_1 = (0, tslib_1.__importDefault)(require("eventemitter3"));
const types_1 = require("../types");
class SlopeWalletAdapter extends eventemitter3_1.default {
    constructor() {
        super();
        this.connect = () => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            if (this._onProcess) {
                return;
            }
            if (window.Slope === undefined) {
                window.open("https://www.slope.finance/", "_blank", "noopener noreferrer");
                throw new Error("Slope not installed");
            }
            this._onProcess = true;
            const wallet = new window.Slope();
            yield wallet
                .connect()
                .then(({ msg, data }) => {
                if (!data.publicKey) {
                    throw new Error(msg);
                }
                this._publicKey = new web3_js_1.PublicKey(data.publicKey);
                this._connected = true;
                this.emit("connect", this._publicKey);
            })
                .catch(() => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
                yield this.disconnect();
            }))
                .finally(() => {
                this._onProcess = false;
            });
        });
        this._onProcess = false;
        this._connected = false;
    }
    get connected() {
        return this._connected;
    }
    get autoApprove() {
        return false;
    }
    signAllTransactions(transactions) {
        var _a, _b;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            if (!window.Slope) {
                throw new Error("Slope not found");
            }
            const wallet = new window.Slope();
            const messages = [];
            transactions.map((transaction) => {
                messages.push(bs58.encode(transaction.serializeMessage()));
            });
            const { msg, data } = yield wallet.signAllTransactions(messages);
            const length = transactions.length;
            if (!data.publicKey || ((_a = data.signatures) === null || _a === void 0 ? void 0 : _a.length) !== length) {
                throw new Error(msg);
            }
            const publicKey = new web3_js_1.PublicKey(data.publicKey);
            for (let i = 0; i < length; i++) {
                (_b = transactions[i]) === null || _b === void 0 ? void 0 : _b.addSignature(publicKey, bs58.decode(data.signatures[i] || ""));
            }
            return transactions;
        });
    }
    get publicKey() {
        return this._publicKey || types_1.DEFAULT_PUBLIC_KEY;
    }
    signTransaction(transaction) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            if (!window.Slope) {
                throw new Error("Slope not found");
            }
            const wallet = new window.Slope();
            const message = bs58.encode(transaction.serializeMessage());
            const { msg, data } = yield wallet.signTransaction(message);
            if (!data.publicKey || !data.signature)
                throw new Error(msg);
            const publicKey = new web3_js_1.PublicKey(data.publicKey);
            const signature = bs58.decode(data.signature);
            transaction.addSignature(publicKey, signature);
            return transaction;
        });
    }
    disconnect() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            if (this._publicKey && window.Slope) {
                this._publicKey = undefined;
                this._connected = false;
                const wallet = new window.Slope();
                yield wallet.disconnect();
                this.emit("disconnect");
            }
        });
    }
}
exports.SlopeWalletAdapter = SlopeWalletAdapter;
//# sourceMappingURL=index.js.map